import { Injectable } from '@angular/core'
import { nginV2Headers, SiteMembership } from '@se-po/shared-data-access-models'
import { map, Observable, throwError } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'

@Injectable({
  providedIn: 'root',
})
export class SiteMembershipService {

  constructor(
    private api: SeFeApiService
  ) { }

  public cancel(membership: SiteMembership, params={}): Observable<SiteMembership> {
    return this.api.put<SiteMembership>(
      `site_memberships/${membership.id}`,
      { status: 'declined'},
      { params , headers: nginV2Headers }
    ).pipe(map(response => response.result))
  }

  public findAll(personaId: string | number, params={}): Observable<SiteMembership[]> {
    return this.api.get<SiteMembership[]>(
      `site_memberships?persona_id=${personaId}`,
      { params , headers: nginV2Headers }
    ).pipe(map(response => response.result))
  }

  public archive(personaIds: string[], orgId: number): Observable<SiteMembership[]> {
    if (!personaIds.length) return throwError(() => new Error('No persona IDs provided'))
    return this.api.put<SiteMembership[]>(
      `ngin/v2/site_memberships/archive`,
      { persona_ids: personaIds.map(id => parseInt(id, 10)), org_id: orgId },
      { headers: nginV2Headers }
    ).pipe(map(response => response.result))
  }
}
